export default function Gallery(element, wrapperInstance) {
    const wrapper = wrapperInstance;
    const dom = {
        root: element,
        skipLink: element.querySelector('.gallery__skip-link'),
        endOfGallery: element.querySelector('#gallery__end'),
        cta: element.querySelector('.gallery__cta'),
        contentContainer: element.querySelector('.gallery__content'),
        slides: element.querySelectorAll('.gallery__slide'),
        alert: element.querySelector('.gallery__at-alert'),
    };

    let state = {
        currentSlide: 0,
        playing: false,
        speed: dom.root.dataset.speed || 5000,
    };

    const firstTransitionDelay = 250;
    let playStartTimeout;
    let playInterval;

    function getState() {
        return state;
    }

    function setState(stateUpdates) {
        state = {
            ...getState(),
            ...stateUpdates,
        };
    }

    function addNavigation() {
        const navigationContainer = document.createElement('div');
        navigationContainer.classList.add('gallery__navigation-container');
        navigationContainer.prepend(createProgressIndicator());
        navigationContainer.append(createControls());
        dom.contentContainer.after(navigationContainer);
        dom.controlsContainer = dom.root.querySelector('.gallery__controls-container');
        dom.backButton = dom.root.querySelector('.gallery__control__back');
        dom.playButton = dom.root.querySelector('.gallery__control__play');
        dom.nextButton = dom.root.querySelector('.gallery__control__next');
        dom.progressIndicator = dom.root.querySelector('.gallery__progess-indicator-container');
    }

    function createControls() {
        const controlsHtml = `
        <button class="gallery__control gallery__control__back">
            <span class="gallery__control__label off-screen">${__('button_label_back')}</span>
            <svg class="gallery__control-icon" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.94 30.08"><path fill="#010101" d="M4.85 13.35l16.09 16.72h-6.35L0 15.04 14.59 0h6.35L4.85 16.73v-3.38z"/></svg>
        </button>
        <button class="gallery__control gallery__control__play">
            <div class="control-state control-state--play">
                <span class="gallery__control__label off-screen">${__('button_label_play')}</span>
                <svg class="gallery__control-icon gallery__control-icon--play" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.23 30.08"><path fill="#010101" d="M23.23 15.04L0 0v30.07l23.23-15.03z"/></svg>
            </div>

            <div class="control-state control-state--pause">
                <span class="gallery__control__label off-screen">${__('button_label_pause')}</span>
                <svg class="gallery__control-icon gallery__control-icon--pause" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.56 28.61"><path d="M16.09 0v28.61h6.47V0zM0 28.61h6.47V0H0z" fill="#010101"/></svg>
            </div>

             <div class="control-state control-state--replay">
                <span class="gallery__control__label off-screen">${__('button_label_replay')}</span>
                <svg class="gallery__control-icon gallery__control-icon--replay" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.4 30.3"><path d="M13.2 3.9V0L6.1 7.2l7.2 7.2v-4c3.7 0 6.8 3.1 6.8 6.8S17 24 13.3 24c-3.7 0-6.8-3-6.8-6.8H0c0 7.3 5.9 13.2 13.2 13.2 7.3 0 13.2-5.9 13.2-13.2 0-7.4-5.9-13.3-13.2-13.3z" fill="#141414"/></svg>
            </div>
        </button>
        <button class="gallery__control gallery__control__next">
            <span class="gallery__control__label off-screen">${__('button_label_next')}</span>
            <svg class="gallery__control-icon" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.94 30.08"><path fill="#010101" d="M16.09 13.35L0 30.07h6.35l14.59-15.03L6.35 0H0l16.09 16.73v-3.38z"/></svg>
        </button>
        `;
        const controls = document.createElement('div');
        controls.innerHTML = controlsHtml;
        controls.classList.add('gallery__controls-container');
        controls.setAttribute('data-playstate', 'paused');
        return controls;
    }

    function createProgressIndicator() {
        const progressIndicator = document.createElement('div');
        progressIndicator.classList.add('gallery__progess-indicator-container');
        progressIndicator.setAttribute('role', 'presentation');

        const steps = document.createElement('ol');
        steps.classList.add('gallery__progess-indicator-steps');
        let stepsHtml = '';
        for (let i = 0; i < dom.slides.length; i++) {
            if (i === 0) {
                stepsHtml += '<li class="gallery__progess-indicator-step gallery__progess-indicator-step--current"></li>';
            }
            else {
                stepsHtml += '<li class="gallery__progess-indicator-step"></li>';
            }
        }
        steps.innerHTML = stepsHtml;
        progressIndicator.append(steps);

        return progressIndicator;
    }

    function setProgressIndicator(index = 0) {
        if (!dom.progressIndicator) return;

        const progressIndicatorSteps = dom.progressIndicator.querySelectorAll('.gallery__progess-indicator-step');
        if (progressIndicatorSteps.length < 2) return;

        for (let i = 0; i < dom.slides.length; i++) {
            if (i === index) {
                progressIndicatorSteps[i].classList.add('gallery__progess-indicator-step--current');
            }
            else {
                progressIndicatorSteps[i].classList.remove('gallery__progess-indicator-step--current');
            }
        }
    }

    function updateUiForIndex(index = 0) {
        setProgressIndicator(index);

        if (index === 0) {
            updateUiToStartView();
        }
        else {
            clearUiStartView();
        }

        if (index >= dom.slides.length - 1) {
            updateUiToEndView();
        }
        else {
            clearUiEndView();
        }
    }

    function addEvents() {
        dom.skipLink.addEventListener('click', (ev) => {
            ev.preventDefault();
            wrapper.scrollTo({
                position: dom.endOfGallery.getBoundingClientRect().top,
                duration: 0,
            });
            dom.endOfGallery.setAttribute('tabindex', 0);
            dom.endOfGallery.focus();
            wrapper.trackUserAction('skip gallery link clicked', getGalleryModeStatusMessage());
        }, false);

        dom.endOfGallery.addEventListener('blur', () => {
            dom.endOfGallery.setAttribute('tabindex', -1);
        }, false);

        dom.backButton.addEventListener('click', () => {
            pauseGalleryIfPlaying();
            wrapper.trackUserAction('back button clicked', `slide ${getState().currentSlide + 1}, ${getGalleryModeStatusMessage()}`);
            back();
        }, false);

        dom.playButton.addEventListener('click', () => togglePlayState(), false);

        dom.nextButton.addEventListener('click', () => {
            pauseGalleryIfPlaying();
            wrapper.trackUserAction('next button clicked', `slide ${getState().currentSlide + 1}, ${getGalleryModeStatusMessage()}`);
            next();
        }, false);
    }

    function displaySlide(index = 0) {
        wrapper.trackBackgroundEvent('display slide', `slide ${getState().currentSlide + 1}, ${getGalleryModeStatusMessage()}`);
        for (let s = 0; s < dom.slides.length; s++) {
            dom.slides[s].classList.remove('gallery__slide--display');
        }
        dom.slides[index].classList.add('gallery__slide--display');
        updateUiForIndex(index);
        updateAlert(index);
    }

    function updateAlert(index = 0) {
        const imgDescriptionElt = dom.slides[index].querySelector('.figure__img');
        const imgDescription = imgDescriptionElt ? imgDescriptionElt.getAttribute('alt') : '';
        const descriptionLabelText = (typeof imgDescription === 'string' && imgDescription.length > 0) ? __('image_description') : 0;
        const descriptionFullText = descriptionLabelText ? `${descriptionLabelText}: ${imgDescription}.` : '';

        const captionElt = dom.slides[index].querySelector('.figure__figcaption__caption-container');
        const captionText = captionElt ? `${captionElt.innerText}.` : '';

        const attributionElt = dom.slides[index].querySelector('.figure__attribution');
        const attributionText = attributionElt ? `${attributionElt.innerText}.` : '';

        const alertContent = `
            ${substituteValues(__('progress_indicator'), {
                n: index + 1,
                total: dom.slides.length,
            })}.
            ${descriptionFullText}
            ${captionText}
            ${attributionText}`;
        dom.alert.innerHTML = alertContent;
    }

    function clearAlert() {
        dom.alert.innerHTML = '';
    }

    function initGallery() {
        dom.root.classList.add('gallery__container--js-enabled');
        dom.cta.removeAttribute('role');
        addNavigation();
        addEvents();
        displaySlide(getState().currentSlide);
    }

    function playGallery() {
        clearTimeout(playStartTimeout);
        clearInterval(playInterval);
        dom.alert.innerHTML = ' ';
        const { speed, currentSlide } = getState();
        let reset = false;
        if (currentSlide >= dom.slides.length - 1) {
            reset = true;
        }
        dom.controlsContainer.setAttribute('data-playstate', 'playing');
        if (reset) {
            wrapper.trackUserAction('restart button clicked', `slide ${getState().currentSlide + 1}`);
            setState({
                playing: true,
                currentSlide: 0,
            });
            displaySlide(getState().currentSlide);
            playInterval = setInterval(() => next(), speed);
        }
        else {
            wrapper.trackUserAction('play button clicked', `slide ${getState().currentSlide + 1}`);
            setState({
                playing: true,
                currentSlide: currentSlide + 1,
            });
            playStartTimeout = setTimeout(() => {
                displaySlide(getState().currentSlide);
                playInterval = setInterval(() => next(), speed);
            }, firstTransitionDelay);
        }
    }

    function pauseGallery() {
        setState({
            playing: false,
        });
        dom.controlsContainer.setAttribute('data-playstate', 'paused');
        clearTimeout(playStartTimeout);
        clearInterval(playInterval);
        clearAlert();
    }

    function pauseGalleryIfPlaying() {
        const { playing } = getState();
        if (playing) {
            pauseGallery();
        }
    }

    function updateUiToStartView() {
        dom.backButton.setAttribute('disabled', true);
    }

    function clearUiStartView() {
        dom.backButton.removeAttribute('disabled');
    }

    function updateUiToEndView() {
        pauseGallery();
        dom.root.setAttribute('data-last-slide', true);
        dom.nextButton.setAttribute('disabled', true);
    }

    function clearUiEndView() {
        dom.root.removeAttribute('data-last-slide');
        dom.nextButton.removeAttribute('disabled');
    }

    function togglePlayState() {
        const { playing } = getState();
        if (playing) {
            pauseGallery();
            wrapper.trackUserAction('pause button clicked', `slide ${getState().currentSlide + 1}`);
        }
        else {
            playGallery();
        }
    }

    function back() {
        const { currentSlide: startSlide } = getState();
        if (startSlide > 0) {
            setState({
                currentSlide: startSlide - 1,
            });
            displaySlide(getState().currentSlide);
        }
    }

    function next() {
        const { currentSlide: startSlide } = getState();
        if (startSlide < dom.slides.length - 1) {
            setState({
                currentSlide: startSlide + 1,
            });
            const { currentSlide: newSlide } = getState();
            displaySlide(newSlide);
        }
    }

    function substituteValues(string, valuesObject) {
        let newString = string;
        Object.keys(valuesObject).forEach((k) => {
            newString = newString.split(`[${k}]`).join(valuesObject[k]);
        });
        return newString;
    }

    function getGalleryModeStatusMessage() {
        return (getState().playing ? 'play mode' : 'manual mode');
    }

    initGallery();

    return {
        dom,
    };
}
